<template>
  <el-dialog title="回复" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="120px">
      <el-form-item label="回复" prop="replyContent">
        <el-input v-model="form.replyContent" type="textarea" :rows="5" placeholder="请输入" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import custServiceGuestbookApi from '@/api/customer/custServiceGuestbook'
function initFormBean() {
  const formBean = {
    id: null,
    replyContent: null,
  }
  return formBean
}

export default {
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        replyContent: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      isRepSub: false
    }
  },
  created() {

  },
  methods: {
    resetForm() {
      this.form = initFormBean()
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { id: row.id, replyContent: null }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          custServiceGuestbookApi.update(this.form).then((data) => {
            this.postCallback(data)
          }).catch(res => {
            this.isRepSub = false
          });
        }
      });
    },
    postCallback(data) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}

.ipt-box {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  padding-right: 20px;
  i {
    font-size: 16px;
    cursor: pointer;
  }
}
.input-box:last-child {
  margin-bottom: 0;
}

::v-deep .el-icon-plus,
.el-icon-minus {
  margin-left: 4px;
  color: #60b7dc;
}
</style>
